export default __webpack_public_path__ + "static/media/17 DUENA DE MI PROPIA OSCURIDAD.9c6e7465.png";